import { render, staticRenderFns } from "./bingo.vue?vue&type=template&id=39dee1b0&"
import script from "./bingo.vue?vue&type=script&lang=js&"
export * from "./bingo.vue?vue&type=script&lang=js&"
import style0 from "./bingo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports